import {Component} from "@angular/core";
import {Employee} from "../../../../../../../../server/src/base/entities/employee/Employee";
import {IEmployeesService} from "../../../../../domain/employees/IEmployeesService";

@Component({
    selector: "home-presentation",
    styleUrls: ['./presentation.scss'],
    templateUrl: "./presentation.html"
})
export class GarageMainPresentationComponent{

    employees:Array<Employee> = [];

    constructor(private employeeService:IEmployeesService){
    }

    ngOnInit(){
        this.employeeService.GetAll().then(employees => {
            this.employees = employees.Value();
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/main/presentation/presentation.ts